import {
    Button,
    ButtonText,
    FormField,
    Input,
    InputField,
    VStack
} from "@hosttools/frontend/components";
import type React from "react";
import {memo, useCallback} from "react";

import Paragraph from "../Paragraph";

import type {CredentialsType, Errors} from "@/admin/components/ModalAddAccount/types";

type Props = {
    credentials: CredentialsType;
    errors?: Errors;
    onChangeCredentials: (field: "propertyID", value: string) => void;
};

const BookingCredential: React.FC<Props> = ({credentials, errors, onChangeCredentials}) => {
    const handleChangePropertyID = useCallback(
        (text: string) => {
            onChangeCredentials("propertyID", text);
        },
        [onChangeCredentials]
    );

    return (
        <VStack space="md">
            <Paragraph variant="sm">
                <b>1.</b> Click the button below to select <b>Host Tools</b> as your{" "}
                <b>Connectivity Provider</b> on Booking.com.
            </Paragraph>
            <a
                className="inline-block"
                href="https://admin.booking.com/?groups_redirect=%2Fhotel%2Fhoteladmin%2Fextranet_ng%2Fmanage%2Fchannel-manager%2Fwidget.html?provider_id=1590"
                rel="noopener noreferrer"
                target="_blank"
            >
                <Button className="w-full">
                    <ButtonText>Select Connectivity Provider</ButtonText>
                </Button>
            </a>
            <Paragraph variant="sm">
                <b>2.</b> Once you have selected <b>Host Tools</b> as your
                <b> Connectivity Provider</b> it can take a few minutes for Booking.com to complete
                the request. You will receive a &quot;Connection activated&quot; message in your
                Booking.com <b>Inbox</b>
                once the activation is complete.
            </Paragraph>
            <Paragraph variant="sm">
                <b>3.</b> Once your connection is activated, enter your
                <b> Booking.com Property ID</b> below and click
                <b> Add Account</b>. It can take a few minutes for your account connection to be
                confirmed on Booking.com before it can be added to Host Tools. If you have trouble
                connecting your account, please confirm that Host Tools is your connectivity
                provider on Booking.com, wait a few minutes and try again.
            </Paragraph>
            <FormField
                error={errors?.propertyID}
                label="Booking.com Property ID"
                tooltip="Enter your Booking.com property ID."
            >
                <Input isRequired>
                    <InputField
                        autoComplete="off"
                        id="propertyID"
                        name="propertyID"
                        placeholder="Booking.com Property ID..."
                        value={credentials.propertyID}
                        onChangeText={handleChangePropertyID}
                    />
                </Input>
            </FormField>
        </VStack>
    );
};

export default memo(BookingCredential);
